import { AdditionalServicesDetails, getAdditionalServicesDetails } from '@cp-mx/common';
import { DefaultBusinessMarketApiErrorCode } from '@cp-shared-19/common-utilities';
import { getSimpleDataFetchSlice } from '@cp-shared-19/frontend-integration';
import { CpDataApi } from '../../cp-xhr';

const { reducer, fetchData } = getSimpleDataFetchSlice<AdditionalServicesDetails[], DefaultBusinessMarketApiErrorCode>({
    dataName: 'additionalServices',
    fetchCallback() {
        return CpDataApi.get(getAdditionalServicesDetails()).then(response => response.data);
    },
});
export default reducer;
export const fetchAdditionalServices = fetchData;
